module.exports = __webpack_public_path__ + "static/media/game-with-friend.c182156b.svg";